module.exports = __webpack_public_path__ + "static/assets/6608d56b3dce2738b2b137569d305d3b.png";